import { useEffect, useRef } from 'react';
export const useAutofocus = ({
  autoFocus = true,
  focusTimeout = 0
} = {}) => {
  const timeoutIdRef = useRef();
  const inputFieldRef = useRef();
  useEffect(() => {
    if (autoFocus) {
      const timeoutId = setTimeout(() => {
        if (inputFieldRef.current) {
          inputFieldRef.current.focus();
        }
      }, focusTimeout);
      timeoutIdRef.current = timeoutId;
    }

    return () => {
      if (timeoutIdRef.current) {
        clearInterval(timeoutIdRef.current);
      }
    };
  }, [autoFocus, inputFieldRef, focusTimeout]);
  return {
    inputFieldRef
  };
};